import { first } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../services';

@Component({
    styles: [`
        .error-block {
            display: block;
        }
    `],
    template: `
        <mat-toolbar color="primary">Briefing Center</mat-toolbar>
        <form (ngSubmit)="reset()" style="height: 100%" fxLayoutAlign="center center" #resetForm="ngForm">
            <spinner *ngIf="noTouching"></spinner>
            <mat-card *ngIf="!noTouching" fxFlex="60">
                <mat-card-content>
                    <div fxLayout="column">
                        <h2>Reset Password</h2>
                        <mat-form-field>
                            <input  matInput
                                    type="password"
                                    placeholder="Password"
                                    name="passwordCtrl"
                                    [(ngModel)]="password"
                                    validateEqual="confirmPasswordCtrl" 
                                    reverse="true"
                                    #passwordCtrl="ngModel"
                                    required
                                    pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$">
                            <mat-error *ngIf="passwordCtrl.hasError('required')">Password cannot be blank.</mat-error>                
                            <mat-error *ngIf="passwordCtrl.hasError('pattern')">Password must contain at least one upper case letter, one lowercase letter, one number and be at least 8 characters long.</mat-error>                
                        </mat-form-field>
                        <mat-form-field style="padding-top: 5px;">
                            <input  matInput
                                    type="password"
                                    placeholder="Password"
                                    name="confirmPasswordCtrl"
                                    [(ngModel)]="confirmPassword"
                                    validateEqual="passwordCtrl" 
                                    reverse="false"
                                    #confirmPasswordCtrl="ngModel">
                            <mat-error *ngIf="confirmPasswordCtrl.hasError('validateEqual')">Passwords do not match.</mat-error>                
                        </mat-form-field>
                    </div>
                </mat-card-content>
                <mat-card-actions>
                    <button mat-raised-button type="submit" color="primary" [disabled]="!resetForm.valid">Reset Password</button>
                </mat-card-actions>
            </mat-card>
        </form>
    `
})
export class ResetPasswordPaneComponent implements OnInit {
    password: string;
    confirmPassword: string;
    noTouching: boolean;

    constructor(private userService: UserService,
                private router: Router,
                private route: ActivatedRoute,
                public snackBar: MatSnackBar){}

    reset = () => {
        this.noTouching = true;
        this.userService.resetPassword(this.route.snapshot.queryParams.token, this.password).pipe(first())
        .subscribe(
            () => this.router.navigate(['client']),
            error => {
                if(error.status === 401){
                    this.snackBar.open('Your token has expired, please request a new one.', 'OK', { duration: 10000, panelClass: ['errorSnackbar']});
                    this.router.navigate(['/login'], { queryParams: { 'start': 'passwordReset' }})
                } else {
                    this.snackBar.open('Unable to change your password, please contact your site administrator.', 'OK', { duration: 10000, panelClass: ['errorSnackbar']});
                }
            }
        );
    };

    ngOnInit() {
        return !this.route.snapshot.queryParams.token ? this.router.navigate(['/login'], { queryParams: { 'start': 'passwordReset' }}) : null;
    }
}
